// Modo de agenda do vínculo (Parte 6.2; REQ-PPL-006, 007; regra 9 da Parte 0.3): vínculos fixos (`Socio`, `CLT`,
// `Estagiario`) têm escala de trabalho (`WorkSchedule`); vínculos flexíveis (`PJ`, `CooperadoCPESQ`) NÃO têm campos de
// jornada — só disponibilidade declarada (`AvailabilityDeclaration`). A interface nunca exibe escala num flexível
// (o servidor também recusa: `422 PPL_NO_WORK_SCHEDULE_FOR_FLEXIBLE_LINK`).
export type ScheduleMode = 'fixed' | 'flexible';

/** Tipos de vínculo com escala de trabalho. */
export const FIXED_LINK_TYPES: readonly string[] = ['Socio', 'CLT', 'Estagiario'];

/** Tipos de vínculo sem jornada (só disponibilidade declarada). */
export const FLEXIBLE_LINK_TYPES: readonly string[] = ['PJ', 'CooperadoCPESQ'];

/** `fixed` para Sócio, CLT e Estagiário; `flexible` para PJ, Cooperado e qualquer tipo desconhecido (nunca jornada por engano). */
export function scheduleModeFor(linkType: string): ScheduleMode {
  return FIXED_LINK_TYPES.includes(linkType) ? 'fixed' : 'flexible';
}
